import { render, staticRenderFns } from "./orderList2.vue?vue&type=template&id=9a62d64a&scoped=true"
import script from "./orderList2.vue?vue&type=script&lang=js"
export * from "./orderList2.vue?vue&type=script&lang=js"
import style0 from "./orderList2.vue?vue&type=style&index=0&id=9a62d64a&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/shop/orderList.less?vue&type=style&index=1&id=9a62d64a&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a62d64a",
  null
  
)

export default component.exports